export default __webpack_public_path__ + "static/media/green_i_icn.65e9a219.svg";